export default "__VITE_ASSET__da67a395__"